import api from './client';

export const purchaseApi = {
  locations:        (params?: any) => api.get('/locations', { params }),
  addLocation:      (data: any)    => api.post('/locations', data),
  branches:         ()             => api.get('/branches'),
  orders:           (params?: any) => api.get('/purchase-orders', { params }),
  createOrder:      (data: any)    => api.post('/purchase-orders', data),
  getOrder:         (id: number)   => api.get(`/purchase-orders/${id}`),
  grns:             (params?: any) => api.get('/grns', { params }),
  createGrn:        (data: any)    => api.post('/grns', data),
  confirmGrn:       (id: number)   => api.post(`/grns/${id}/confirm`, {}),
  getLandedCosts:   (id: number)   => api.get(`/grns/${id}/landed-costs`),
  addLandedCost:    (id: number, data: any) => api.post(`/grns/${id}/landed-costs`, data),
  deleteLandedCost: (grnId: number, costId: number) => api.delete(`/grns/${grnId}/landed-costs/${costId}`),
  importPreview:    (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/grns/import-preview', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  importSave:          (grnId: number, data: any) => api.post(`/grns/${grnId}/import-save`, data),
  supplierInvoices:    (params?: any) => api.get('/supplier-invoices', { params }),
  createSupplierInvoice: (data: any) => api.post('/supplier-invoices', data),
  supplierPayments:    () => api.get('/supplier-payments'),
  createSupplierPayment: (data: any) => api.post('/supplier-payments', data),
};
